import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_289: DocMigration = {
  maxSchemaVersion: "0.0.289",
  description: "Roof facade legacy flag",
  apply(json: any): any {
    // look for facades applied to roofs
    const isRoofFacade: { [id: string]: boolean } = {};
    for (const roofId in json.roofs) {
      const { gableEndLabels } = json.roofs[roofId];
      if (!gableEndLabels) {
        continue;
      }

      for (const { name } of gableEndLabels) {
        isRoofFacade[name] = true;
      }
    }

    // set the legacy behavior flag for the roof facades
    for (const facadeId in isRoofFacade) {
      const facade = json.facades[facadeId];
      if (!facade) {
        continue;
      }

      json.facades[facadeId] = {
        ...facade,
        legacyRoofBehavior: true,
      };
    }
    return json;
  },
};

export default migration_0_0_289;
